import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PRICING_PLANS, CONTACT } from "../data/content";
import { SectionHeader, CTABand } from "./Home";
import { WhatsAppIcon } from "../components/SiteLayout";

export default function PricingPage() {
  return (
    <div data-testid="pricing-page">
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeader
            eyebrow="Pricing"
            title="Simple pricing for due diligence."
            sub="Every plan is reviewed by our legal experts and delivered as a structured PDF with a Land Rating out of 100. Prices are per property."
            className="mb-16"
          />
          <div className="grid md:grid-cols-3 gap-6 items-start">
            {PRICING_PLANS.map((p) => (
              <div
                key={p.id}
                data-testid={`pricing-plan-${p.id}`}
                className={`p-10 border ${p.highlight ? "border-[#C1A74A] shadow-[0_24px_60px_rgba(17,56,53,0.12)]" : "border-[#113835]/12"}`}
              >
                {p.highlight && (
                  <p className="font-heading text-[0.6rem] uppercase tracking-[0.22em] text-[#C1A74A] mb-3">Most Chosen</p>
                )}
                <h2 className="font-heading text-lg font-medium text-[#113835]">{p.name}</h2>
                <p className="font-heading text-4xl font-semibold text-[#113835] mt-4">{p.price}</p>
                <p className="text-xs text-gray-400 mt-1 uppercase tracking-[0.12em] font-heading">{p.period}</p>
                <p className="text-sm text-gray-600 font-light mt-4">{p.description}</p>
                <ul className="mt-7 space-y-3">
                  {p.includes.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-gray-600 font-light">
                      <Check size={15} strokeWidth={2} className="text-[#C1A74A] mt-0.5 shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <p className="mt-6 text-xs text-gray-400 font-light">Turnaround: {p.turnaround}</p>
                {p.cta === "contact" ? (
                  <a
                    href={`https://wa.me/91${CONTACT.phoneRaw}?text=${encodeURIComponent("Hi Terraa & Title, I'd like to discuss a Priority / Complex property review.")}`}
                    target="_blank" rel="noopener noreferrer"
                    data-testid={`pricing-cta-${p.id}`}
                    className="tt-btn-outline w-full justify-center mt-8"
                  >
                    <WhatsAppIcon size={15} /> Talk to Us
                  </a>
                ) : (
                  <Link to="/request-title-search" data-testid={`pricing-cta-${p.id}`} className={`${p.highlight ? "tt-btn-gold" : "tt-btn-outline"} w-full justify-center mt-8`}>
                    Request Verification <ArrowRight size={14} strokeWidth={1.5} />
                  </Link>
                )}
              </div>
            ))}
          </div>
          <div className="mt-14 border border-[#113835]/10 bg-[#F9FAFA] p-8">
            <p className="font-heading text-sm font-medium text-[#113835]">Custom & volume pricing</p>
            <p className="mt-2 text-sm text-gray-600 font-light leading-relaxed max-w-3xl">
              Agents, law firms, lenders, and developers working across multiple properties can request custom
              arrangements. Turnaround depends on property type, location, and record availability — complex or
              litigated matters are scoped individually before we begin.
            </p>
          </div>
          <p className="mt-8 text-xs text-gray-400 font-light max-w-3xl">
            All reports are expert summaries based on documents and records reviewed at the time of review.
            They are not title insurance and not a substitute for independent legal advice where required.
          </p>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
